export const START_FETCH_INVENTORY = 'START_FETCH_INVENTORY';
export const SUCCESS_FETCH_INVENTORY = 'SUCCESS_FETCH_INVENTORY';
export const ERROR_FETCH_INVENTORY = 'ERROR_FETCH_INVENTORY';
